import { SideSheetHeader } from "@opensea/ui-kit"
import type { Address } from "../../../../types"
import { ViewWalletHeaderProfileSection } from "./ViewWalletHeaderProfileSection"

type ViewWalletHeaderProps = {
  address: Address
}

export function ViewWalletHeader({ address }: ViewWalletHeaderProps) {
  return (
    <SideSheetHeader>
      <ViewWalletHeaderProfileSection address={address} />
    </SideSheetHeader>
  )
}
